// 浏览器标签页默认的标题
// TODO:修改默认标题
import UserPersistence from '../persistence/UserPersistence'

export const DEFAULT_WINDOW_TITLE = "首页";
//服务器返回这些错误时，直接弹窗提示 "服务器异常，请稍后再试！"
export const COMMON_SERVER_ERROR_MESSAGE = "网络异常，请稍后再试！";
export const COMMON_SERVER_ERROR_CODES = ["400", "403", "404", "500", "501", "502", "503"];
//40000 以上的服务器异常代码，直接使用服务器返回的errorMessage提示给用户
export const BASER_SERVER_ERROR_CODE_WITH_ERROR_MESSAGE = 40000;

export const WHITE_LIST_CODE = ['22222', '33333'];

export const DURATION_OF_SERVER_ERROR_MESSAGE = 5000;
//默认提示框持续时间
export const DURATION_DEFAULT = 4000;

export const ALONE_APP_MODE = "alone";


export const MUTATION_INIT_STATE = "@@initState";
export const MUTATION_CLEAR_STATE = "@@clearState";
export const SERVICE_TYPE = {//各系统代码
  ZYGL: '21',
};

export const APP_MODE = {//各版本代码
  PRO: 'production',//企业正式
  UAT: 'uat',//企业测试
  EDU_UAT: 'edu-uat',//教育实训测试
  EDU_SX: 'edu-sx',//教育实训正式
  EDU_KSUAT: 'edu-ksuat',//教育考试测试
  EDU_KS: 'edu-ks',//教育考试正式
  EDU_DXUAT: 'edu-dxuat',//教育单项测试
  EDU_DX: 'edu-dx',//教育单项正式
  EDU_DX2: 'edu-dx2',//教育考试正式2
};

export const IDENTITY_NAME = {
  basicdata: '运营中心',
  imagecenter: '影像中心',
  reimburse: '报账中心',
  settlement: '结算中心',
  journal: '会计核算',
  bill: '票据管理',
  asset: '资产管理',
  salary: '薪资管理',
  tax: '金税师',
  travel: '商旅费控',
  purchase: '采购管理',
  sale: '销售管理',
  inventory: '库存管理',
};

export const REGULAR_CODE = {
  LANDLINE_REG:new RegExp('^([0-9]{3,4}-)?[0-9]{7,8}$'),//座机
  PHONE_REG: new RegExp('^[1][3,4,5,6,7,8,9][0-9]{9}$'),//手机号
  EMAIL_REG: new RegExp('^[a-z0-9]+([._\\\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]){1,63}\\.[a-z0-9]+$'),//邮箱
  ID_NUMBER_REG: new RegExp('(^\\d{15}$)|(^\\d{18}$)|(^\\d{17}(\\d|X|x)$)'),//身份证号
  USER_CODE_REG: new RegExp('^[a-zA-Z0-9]{6,10}$'),//用户编码
  COMPANY_CODE_REG: new RegExp('^[0-9a-zA-Z_]{6,20}$'),//公司编码
  MONEY_MAX_REG:new RegExp('^-?((\\d{0,13})|([0]{1}))((\\.(\\d){1,2}))?$'),//金额 最大为9999999999.99
  MONEY_MAX_POS_REG: new RegExp('^((\\d{0,10})|([0]{1}))((\\.(\\d){1,2}))?$'),//大于0金额 最大为9999999999.99
  MONEY_MAX_POX_REG: new RegExp('^((\\d{0,9})|([0]{1}))((\\.(\\d){1,2}))?$'),//大于0金额 最大为9999999999.99
  INTEGER_NUM_REG: new RegExp("^\\d+$"), //正整数(不包括小数)
};

//根据配置文件设置全局变量
export const ENV = function() {
  if (window.config) {
    return {
      ...process.env,
      ...window.config
    }
  } else {
    return process.env
  }
}();


/**
 * 退出地址
 * @returns {string}
 * @constructor
 */

export const EXIT_URL = function() {
  let token = UserPersistence.getToken();
  return ENV.EXIT_URL + '?token=' + token;
};





// WEBPACK FOOTER //
// ./src/config/app.js